import { render, staticRenderFns } from "./AllowanceForm.vue?vue&type=template&id=531fe84e&scoped=true"
import script from "./AllowanceForm.vue?vue&type=script&lang=js"
export * from "./AllowanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531fe84e",
  null
  
)

export default component.exports